import { render, staticRenderFns } from "./NotificationsItem.vue?vue&type=template&id=d915e896&scoped=true&"
import script from "./NotificationsItem.vue?vue&type=script&lang=js&"
export * from "./NotificationsItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsItem.vue?vue&type=style&index=0&id=d915e896&prod&lang=scss&"
import style1 from "./NotificationsItem.vue?vue&type=style&index=1&id=d915e896&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d915e896",
  null
  
)

export default component.exports